import Joi from "joi-browser";
import useFormState from "V2.0/hooks/useFormState";

import { NewWebhook, WebhookEvent } from "./types";

export default useWebhookForm;

function getWebhookData(webhook: NewWebhook) {
  return {
    webhookName: webhook?.webhookName ?? "",
    endpointUrl: webhook?.endpointUrl ?? "",
    authRequired: webhook?.authRequired ?? false,
    authKey: webhook?.authKey ?? "",
    authHeader: webhook?.authHeader ?? "",
    eventName: webhook?.eventName ?? WebhookEvent.CAPTURE_EVENT,
  };
}

const webhookFormSchema = {
  webhookName: Joi.string().allow(null, "").label("Name"),
  eventName: Joi.string().required().label("Event"),
  endpointUrl: Joi.string().required().label("Webhook URL"),
  authRequired: Joi.boolean().label("Authorization"),
  authKey: Joi.when("authRequired", {
    is: true,
    then: Joi.string().required().label("Auth Key"),
    otherwise: Joi.string().allow(null, "").label("Auth Key"),
  }),
  authHeader: Joi.string().allow(null, "").label("Auth Header"),
} as const;

function useWebhookForm(webhook = {}) {
  const { formState, updateFormState, validate, errors } = useFormState(
    () => getWebhookData(webhook as NewWebhook),
    webhookFormSchema,
  );

  return {
    formState,
    updateFormState,
    validate,
    errors,
  };
}
